import { useEffect, useState, useContext } from "react";
import BasketItemCard from "./BasketItemCard";
import BasketItemDetails from "../Components/BasketItemDetails";
import appConst from "../Utilities/appConst.json";
import { LanguageContext } from "../context/language/LanguageContext";
import { useDispatch } from "react-redux";
import useBasketItemHelpers from "../hooks/useBasketItemHelpers";

const BasketItemMosaic = (props) => {
  const languageContext = useContext(LanguageContext);
  const dispatch = useDispatch();
  const { setCountValue, handleChange, getImageUrl } = useBasketItemHelpers({
    dispatch,
    item: props.item,
    props,
  });

  const [heightQuantity, setHeightQuantity] = useState(0);
  const [widthQuantity, setWidthQuantity] = useState(0);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");

  useEffect(() => {
    const format = props.item.format.toString();
    if (
      format.startsWith(appConst.MOSAIC_FORMAT_PREFIX) &&
      format.length === appConst.MOSAIC_FORMAT_LENGTH
    ) {
      setHeightQuantity(format[1]);
      setWidthQuantity(format[2]);
    }
  }, []);

  // title
  useEffect(() => {
    const mosaicHeight = calcMosaicLength(heightQuantity);
    const mosaicWidth = calcMosaicLength(widthQuantity);

    setTitle(
      languageContext.getTranslation(appConst.MOSAIC) +
        " " +
        heightQuantity +
        "X" +
        widthQuantity +
        " " +
        languageContext.getTranslation(appConst.SQUARES)
    );
    setSubTitle(
      languageContext.getTranslation(appConst.MEASURES) +
        ": " +
        mosaicHeight +
        "X" +
        mosaicWidth +
        " " +
        languageContext.getTranslation(appConst.CM)
    );
  }, [heightQuantity, widthQuantity]);

  const calcMosaicLength = (quantity) => {
    return (
      appConst.TAIL_SIZE * quantity +
      (quantity - 1) * appConst.SCALE_SIZE
    ).toFixed(1);
  };

  return (
    <BasketItemCard
      imageUrl={getImageUrl()}
      imageAlt={title}
      showCheckbox={props.isDeletionMode}
      isChecked={props.isChecked}
      onToggle={handleChange}
      quantity={props.item.quantity}
      setCountValue={setCountValue}
      item={props.item}
      tuneSettingsTitle={title}
    >
      <BasketItemDetails
        isMosaic={true}
        quantity={props.item.quantity}
        item={props.item}
        title={title}
        subTitle={subTitle}
        isShow={true}
        setCountValue={setCountValue}
        imageUrl={getImageUrl()}
        tuneSettingsTitle={title}
      />
    </BasketItemCard>
  );
};
export default BasketItemMosaic;
